/// <reference path="../../typings/index.d.ts" />

module monitoringApp.controllers {
    
    class SuiteReportController {
        constructor(private dataAccessService: common.DataAccessService, private $timeout: ng.ITimeoutService) {
        }

        static $inject = ['dataAccessService', '$timeout'];
        private suiteId: number;
        private dateFilter: string;
        private mainChartData: Array<Number> = [0, 0, 0];
        private browserChartList: Array<Array<number>>;
        private mainChartColors: string[] = ["#4CAF50", "#f7464a", "#eeeeee"];
        private historyResult: entities.ISuiteReportResult;
        private suiteFilter: string = 'all';
        private requestProgress = false;
        private dayPassedData: Array<[number, number]> = [];
        private dayFailedData: Array<[number, number]> = [];
        private dayRunsData: Array<[number, number]> = [];
        private dayPassedPerc: Array<[number, number]> = [];
        private dayFailedPerc: Array<[number, number]> = [];
        private hourFailedData: Array<[number, number]> = [];
       

        private getHistory = (): void => {
            this.requestProgress = true;

            this.dataAccessService.getSuiteReport(this.suiteId, this.dateFilter).then((data) => {
                this.historyResult = data;
                this.mainChartData = [data.summary.passed, data.summary.failed, data.summary.runs - data.summary.failed - data.summary.passed];
                this.browserChartList = data.browsers.map((summary: entities.ISuiteBrowserSummary) => {
                    return [summary.passed, summary.failed, summary.runs - summary.failed - summary.passed]
                });
                this.createCharts(data);
                this.requestProgress = false;
            });

        }

        private createChartData = (data) => {

            this.dayFailedData.length = 0;
            this.dayPassedData.length = 0;
            this.dayRunsData.length = 0;
            this.dayPassedPerc.length = 0;
            this.dayFailedPerc.length = 0;
            this.hourFailedData.length = 0;

    
            angular.forEach(data.byDay, (value, key) => {
                this.dayPassedData.push([key, value.passed]);
                this.dayFailedData.push([key, value.failed]);
                this.dayRunsData.push([key, value.runs]);
                this.dayPassedPerc.push([key,value.runs != 0 ? value.passed / value.runs * 100 : 0]),
                    this.dayFailedPerc.push([key, value.runs != 0 ? value.failed / value.runs * 100: 0])
            });

           
            angular.forEach(data.byHour, (value, key) => {
                this.hourFailedData.push([key, value.failed]);
            });



        };

        private refreshCharts = () => {
            this.$timeout(function () {
                window.dispatchEvent(new Event('resize'));
            }, 0);
        }

    
        private createCharts = (data) => {
            this.createChartData(data);
            this.refreshCharts();
        }


    }

    angular.module("ultimateMonitoringApp").controller("suiteReportController", SuiteReportController);
}

